import { default as panelTemplate } from "./panel/template.jst";
import Button from "./controls/button";

import View from "backdraft-app/src/view";

import _ from "underscore";
import $ from "jquery";

class Panel extends View {
  constructor(...args) {
    super(...args);

    if (!this.body && !this.template) {
      throw new Error("You must provide a body or template to the panel");
    }

    _.defaults(this, {
      buttons: [],
      panelClasses: "",
      actionsClasses: ""
    });

    if (this.wizard) {
      this.panelClasses = `${this.panelClasses} panel-wizard`;

      if (this.wizard.progress) {
        this.actions = `<div class="progress"><div class="progress-bar" role="progressbar" style="width: ${this.wizard.progress}%">${this.wizard.progress}%</div></div>`;
      }
    }
  }

  render() {
    if (this._accordionWizardEnabled()) {
      this.parent.accordionSteps || this._setupAccordionWizard();
    }

    let bodyClasses = '';
    let headingClasses = '';

    if (this._accordionWizardEnabled()) {
      bodyClasses += "panel-collapse collapse";

      if (this.wizardFirstStep) {
        bodyClasses += " show";
      }
    }

    if (!_.isUndefined(this.collapsible)) {
      bodyClasses += 'collapse';
      headingClasses += 'panel-expandable';
      if (!_.isUndefined(this.collapsible.defaultOpen) && this.collapsible.defaultOpen === true) {
        bodyClasses += ' show';
      }
    }

    this.$el.html(
      panelTemplate({
        title: this.title,
        panelClasses: this.panelClasses,
        actionsClasses: this.actionsClasses,
        bodyClasses,
        headingClasses
      })
    );

    this._buildPageTitle();
    this._buildHeader();
    this._buildActions();
    this._buildBody();
    this._buildButtons();

    return this;
  }

  _setupAccordionWizard() {
    const unorderedSteps = [];
    _(this.parent.children).each(view => {
      if (typeof view.wizardStepIndex !== "undefined") {
        unorderedSteps.push(view);
      }
    });

    this.parent.accordionSteps = _.sortBy(unorderedSteps, "wizardStepIndex");
    this.parent.currentStep = this.parent.accordionSteps[0];
    this.parent.currentStep.wizardFirstStep = true;
    this.parent.accordionSteps[this.parent.accordionSteps.length - 1].wizardLastStep = true;
  }

  _handleAccordionWizardNavigation(e) {
    const currentStepId   = this.parent.currentStep.wizardStepIndex;
    const nextWizardStep  = this.parent.accordionSteps[currentStepId + 1];

    this.parent.currentStep.$(".panel-footer").remove();
    nextWizardStep.$(".panel-content").collapse().collapse('show');
    this.parent.currentStep = nextWizardStep;

    $('html, body').animate({ scrollTop: (nextWizardStep.$el.offset().top) }, 500);

    // You may have to set the type='text' manually in your template
    nextWizardStep.$('input[type="text"]:visible:first').focus();
  }

  _accordionWizardEnabled() {
    return this.parent && this.parent.accordionWizard && this.wizardStepIndex > -1;
  }

  _buildPageTitle() {
    if (this.pageTitle) {
      this.$el.prepend(`<h1 class="pageTitle">${this.pageTitle}</h1>`);
    }

    if (this.pageIcon) {
      this.$el.prepend(`<span class="ui-page-title-logo ${this.pageIcon}"></span>`);
    }
  }

  _buildHeader() {
    if (!_.isUndefined(this.collapsible)) {
      this.$("[data-mount=heading]").attr('data-toggle', 'collapse');
      this.$("[data-mount=heading]").attr('data-target', `[data-body-for="${this.title}"]`);
    }

    if (this.title) {
      this.$(".panel-title").html(_.result(this, "title"));
      if (this.titleMaterialIcon) {
        this.$('.panel-title').prepend(`<i class="material-icons">${this.titleMaterialIcon}</i>`);
      } else if (this.titleIcon) {
        this.$('.panel-title').prepend(`<span class="${this.titleIcon} margin_right_small"></span>`);
      }
    } else {
      this.$(".panel-title").hide();
    }

    if (this.subTitle) {
      this.$(".panel-sub-title").html(_.result(this, "subTitle"));
    } else {
      this.$(".panel-sub-title").hide();
    }
  }

  _buildActions() {
    if (!_.isUndefined(this.collapsible)) {
      if (!_.isUndefined(this.collapsible.defaultOpen) && this.collapsible.defaultOpen === true) {
        this.$("[data-mount=actions]").html('<i class="material-icons" data-toggle-icon="down">keyboard_arrow_down</i>');
      } else {
        this.$("[data-mount=actions]").html('<i class="material-icons" data-toggle-icon="up">keyboard_arrow_left</i>');
      }
      this._bindCollapseAction();
    } else if (this.actions) {
      this.$("[data-mount=actions]").html(this.actions);
    }
  }

  _bindCollapseAction() {
    this.$(".panel").on("click", "[data-mount=heading]", function() {
      const $toggleIcon = $(this).find("i[data-toggle-icon]");
      if ($toggleIcon.data('toggle-icon') === "down") {
        $toggleIcon.data('toggle-icon', 'up');
        $toggleIcon.text('keyboard_arrow_left');
      } else {
        $toggleIcon.data('toggle-icon', 'down');
        $toggleIcon.text('keyboard_arrow_down');
      }
    });
  }

  _buildBody() {
    if (this.template) {
      this.$("[data-mount=body]").html(this.template(this._templateArgs()));
    } else {
      const body = _.result(this, "body");
      if (_.isString(body)) {
        this.$("[data-mount=body]").html(body);
      } else if (body instanceof View) {
        this.child("body", body);
        this.$("[data-mount=body]").html(body.$el);
      } else {
        throw new Error("Result of body must be a string, or Backbone view");
      }
    }
  }

  _buildButtons() {
    this._addOrRemoveAccordionWizardNextButton();

    const buttons = _.map(_.result(this, "buttons"), function(config) {
      const view = new Button(config).render();
      this.child(`button${view.cid}`, view);

      if (config.data) {
        this._addDataAttributes(config.data, view.$el);
      }

      return view;
    }, this);

    if (buttons.length) {
      this.$("[data-mount=footer]").html(_.pluck(buttons, "$el"));
    } else {
      this.$("[data-mount=footer]").remove();
    }
  }

  _addOrRemoveAccordionWizardNextButton() {
    if (this._accordionWizardEnabled() && !this.wizardLastStep) {
      if (!_.where(this.buttons, button => button.options && (button.options.data.action === "accordion-wizard-next")).length) {
        this.buttons.push({
          click: this._handleAccordionWizardNavigation.bind(this),
          text: "Next",
          className: 'btn-primary',
          data: {
            action: "accordion-wizard-next"
          }
        });
      }
    } else {
      this.buttons = _.reject(_.result(this, "buttons"), button => button.data && (button.data.action === "accordion-wizard-next"));
    }
  }

  _addDataAttributes(data, button) {
    const attributes = Object.keys(data);
    attributes.forEach(attr => {
      button.attr(`data-${attr}`, data[attr]);
    });
  }

  // Overwrite this if your panel's template requires specific arguments
  _templateArgs() {
    return {};
  }
}

export default Panel;
